import stringUtils from "./string_utils.js"
import errorModifier from "./error_modifier.js"

function addGetCurrentLine ({name, source, errorModifierParams, receiveGetCurrentLine}) {
    const splittedSource = source.split("\n")

    const wantedLineRegex = new RegExp(`${stringUtils.escapeForRegExp(encodeURIComponent(name))}[ .].*:(\\d*):(\\d*)[^\\d]*\\n`, "m")

    function getCurrentLine () {
        let error = new Error("fake error")
        let match = error.stack.match(wantedLineRegex)
        if (match) {
            let lineNumber = parseInt(match[1], 10) - errorModifier.linesToRemove(errorModifierParams)
            return {
                lineNumber,
                content: splittedSource[lineNumber - 1]
            }
        } else {
            console.warn("This browser is not supported by Toxilib execute_get_current_line")
            return {}
        }
    }
    receiveGetCurrentLine(getCurrentLine)
}

export default addGetCurrentLine

